<template>
  <div>
    <notify/>
    <v-overlay :value="showOverlay" z-index="1000">
      <div class="d-flex flex-column align-center pa-12">
        <div v-if="customProgress" v-html="customProgress"/>
        <v-progress-circular
          v-else
          indeterminate
          size='64'
        ></v-progress-circular>
        <div v-if="overlayText" class="pt-5">
          <span class="overlay-text">{{ overlayText }}</span>
        </div>
      </div>
    </v-overlay>
  </div>
</template>

<script>
import Notify from '@/components/Notify'
export default {
  components: {
    Notify
  },
  computed: {
    showOverlay() {
      return this.$store.state.general.showModal
    },
    overlayText() {
      return this.$store.state.general.overlayText
    },
    customProgress() {
      return this.$store.state.general.overlayLoader || this.$store.state.general.config.customLoaderHtml
    }
  }
}
</script>
<style lang="scss">
  .overlay-text {
    font-family: Roboto, sans-serif;
  }
</style>